<ng-template #banner>
  <app-data-manager-banner class="vanta-data__viewer-manager-banner"></app-data-manager-banner>
</ng-template>
<div class="vanta-data__viewer-container" *ngIf="!showBanner && !searching; else banner">

    <evc-frame>

        <div frame-title>

            <div class="flex-row result-header-row" *ngIf="infoShowBlade">
                <div class="flex-column flex-1-1-auto result-header" *ngIf="searchResultItem.length === 1">
                    <span class="result-title">
                        {{searchResultItem[0].methodDisplayName}}
                    </span>
                    <span class="result-date">
                        {{ timeTestTaken | date:'MMMM d, y | h:mm:ss a' }}
                    </span>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="exportMenu" aria-label="Export" title="Export">
                    <evc-icon icon="file-export"></evc-icon>
                </button>
                <mat-menu #exportMenu="matMenu">
                    <button mat-menu-item (click)="exportVantaShotCSV()">Export CSV</button>
                    <button mat-menu-item (click)="exportVantaShotJSON()">Export JSON</button>
                </mat-menu>
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Display settings" title="Display settings">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu" class="display-settings-menu">
                    <div class="mat-menu-item flex-row">
                        <mat-label class="flex-1-1-85">Display nSigma</mat-label>
                        <mat-form-field class="flex-1-1-30">
                            <mat-select [(value)]="displaySettings.methodDisplayOptions.displaySigma" (click)="stopClickPropogation($event)"
                                        (selectionChange)="onDisplayShotSettingSelectionChange()" hideSingleSelectionIndicator="true">
                                <mat-option *ngFor="let item of nSigmaVal" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="mat-menu-item flex-row" *ngIf="isShowAuKaratSettingVisible">
                        <mat-label class="flex-1-1-60">Show Au Karat</mat-label>
                        <mat-form-field class="flex-1-1-40">
                            <mat-select [(value)]="auKaratSelected" (click)="stopClickPropogation($event)"
                                        (selectionChange)="onDisplayShotSettingSelectionChange()" hideSingleSelectionIndicator="true">
                                <mat-option *ngFor="let item of auKaratOptionsVal" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="mat-menu-item flex-row" *ngIf="auKaratSelected === 'AuKarat' && isShowAuKaratSettingVisible">
                        <mat-label class="flex-1-1-85">Show Au Karat Decimal</mat-label>
                        <mat-form-field class="flex-1-1-30">
                            <mat-select [(value)]="auKaratDecimalSelected" (click)="stopClickPropogation($event)"
                                        (selectionChange)="onDisplayShotSettingSelectionChange()" hideSingleSelectionIndicator="true">
                                <mat-option *ngFor="let item of auKaratDecimalVal" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <mat-checkbox [checked]="hideChemistry"
                                  (change)="onDisplayShotSettingChange('hideChemistry', $event)"
                                  (click)="stopClickPropogation($event)"
                                  class="mat-menu-item">Hide Chemistry</mat-checkbox>
                    <mat-checkbox [checked]="showEstimatedLod"
                                  (change)="onDisplayShotSettingChange('showEstimatedLod', $event)"
                                  (click)="stopClickPropogation($event)"
                                  class="mat-menu-item">Show Estimated LOD</mat-checkbox>
                    <mat-checkbox [checked]="showUncertainty"
                                  (change)="onDisplayShotSettingChange('showUncertainty', $event)"
                                  (click)="stopClickPropogation($event)"
                                  class="mat-menu-item">Show Uncertainty</mat-checkbox>
                    <mat-checkbox [checked]="showUserFactorName"
                                  (change)="onDisplayShotSettingChange('showUserFactorName', $event)"
                                  (click)="stopClickPropogation($event)"
                                  class="mat-menu-item">Show User Factor Name</mat-checkbox>
                    <mat-checkbox *ngIf="isShowPlateAlertSettingVisible" [checked]="showPlateAlert"
                                  (change)="onDisplayShotSettingChange('showPlateAlert', $event)"
                                  (click)="stopClickPropogation($event)"
                                  class="mat-menu-item">Show Plate Alert</mat-checkbox>
                    <mat-checkbox *ngIf="isShowQuantityAbove10SettingVisible" [checked]="showQuantityAbove10"
                                  (change)="onDisplayShotSettingChange('showQuantityAbove10', $event)"
                                  (click)="stopClickPropogation($event)"
                                  class="mat-menu-item">Show Quantity Above 10</mat-checkbox>
                </mat-menu>
            </div>
        </div>
        <div frame-content>
            <mat-tab-group #dataTabs mat-stretch-tabs class="scroll-section flex-1-1-auto hide-xs"
                           (selectedTabChange)="tabChanged($event)">
                <mat-tab [disabled]="searchResultItem.length > 1" label="Chemistry">
                    <ng-container *ngTemplateOutlet="chemistry"></ng-container>
                </mat-tab>
                <mat-tab [disabled]="searchResultItem.length > 1" label="Spectrum">
                    <ng-container *ngTemplateOutlet="spectrum"></ng-container>
                </mat-tab>
                <mat-tab [disabled]="searchResultItem.length > 1" label="Notes">
                    <ng-container *ngTemplateOutlet="notes"></ng-container>
                </mat-tab>
                <!-- <mat-tab label="Map">
              <ng-container *ngTemplateOutlet="map"></ng-container>
            </mat-tab> -->
            </mat-tab-group>
            <mat-accordion class="show-only-xs">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Chemistry
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngTemplateOutlet="chemistry"></ng-container>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Spectrum
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngTemplateOutlet="spectrum"></ng-container>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Notes
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngTemplateOutlet="notes"></ng-container>
                </mat-expansion-panel>
                <!-- <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Map
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container *ngTemplateOutlet="map"></ng-container>
            </mat-expansion-panel> -->
            </mat-accordion>
        </div>
        </evc-frame>
    </div>
        <ng-template #chemistry>
            <div class="flex-column">
                <div class="flex-row gap-15" *ngIf="infoShowBlade">
                    <div class="flex-column flex-1-1-80">
                        <div class="flex-row" *ngIf="infoShowBlade?.gradeList.length > 0">
                            <mat-radio-group class="grade-list flex-1-1-auto" [(ngModel)]="selectedGrade"
                                             (ngModelChange)="onGradeChanged($event, false)">
                                <mat-radio-button class="grade-list__option" *ngFor="let grade of infoShowBlade.gradeList"
                                                  [value]="grade">
                                    {{grade.gradeName}}
                                </mat-radio-button>
                            </mat-radio-group>
                            <span class="center-align">{{selectedGradeIndex}}/{{infoShowBlade.gradeList.length}}</span>
                        </div>
                        <span *ngIf="infoShowBlade.gradeList.length > 0" class="center-align grade-string">
                            {{ gradeDisplayString }}
                        </span>
                        <mat-radio-group *ngIf="infoShowBlade.passFailGrade" [(ngModel)]="selectedGrade" class="grade-list"
                                         (ngModelChange)="onGradeChanged($event, true)">
                            <mat-radio-button [value]="infoShowBlade.passFailGrade" class="pass-fail-grade">
                                <span [innerHtml]="infoShowBlade.passFailGrade.displayStr"></span>
                            </mat-radio-button>
                        </mat-radio-group>
                        <span *ngFor="let result of infoShowBlade.displayStrings" [innerHtml]="result.displayStr"></span>
                        <span *ngIf="showUserFactorName && infoShowBlade.analysis.userFactorName">User Factor Name: {{infoShowBlade.analysis.userFactorName}}</span>
                    </div>
                    <div class="flex-column flex-0-0-auto">
                        <span>Display nSigma : {{ displaySettings.methodDisplayOptions.displaySigma }}</span>
                        <span *ngIf="auKaratSelected !== 'None' && isShowAuKaratSettingVisible">Show Au Karat : {{ auKaratSelected }}</span>
                        <span *ngIf="auKaratSelected === 'AuKarat' && isShowAuKaratSettingVisible">Show Au Karat Decimal : {{ auKaratDecimalSelected }}</span>
                        <span *ngIf="hideChemistry">Hide Chemistry</span>
                        <span *ngIf="showEstimatedLod">Show Estimated LOD</span>
                        <span *ngIf="showUncertainty">Show Uncertainty</span>
                        <span *ngIf="showUserFactorName">Show User Factor Name</span>
                        <span *ngIf="showPlateAlert && isShowPlateAlertSettingVisible">Show Plate Alert</span>
                        <span *ngIf="showQuantityAbove10 && isShowQuantityAbove10SettingVisible">Show Quantity Above 10</span>
                    </div>
                </div>
                <table #table1 *ngIf="!hideChemistry" mat-table [dataSource]="tableDataSource" matSort #sort1="matSort" matSortDisableClear class="full-width"
                       matSortActive="concentration" matSortDirection="desc">
                    <ng-container matColumnDef="elementName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ displayedColumnNames.elementName }} </th>

                        <td mat-cell *matCellDef="let element">
                            <span class="element-badge"
                                  [matTooltip]="getElementFullName(element.elementName.display)"
                                  matTooltipPosition="right"
                                  matTooltipShowDelay="200"
                                  [innerHtml]="element.elementName.display.trim()">
                            </span>
                        </td>

                    </ng-container>

                    <ng-container matColumnDef="concentration">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ displayedColumnNames.concentration }} </th>
                        <td mat-cell *matCellDef="let element"> {{ element.concentration.display.trim() }} </td>
                    </ng-container>

                    <ng-container matColumnDef="error">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="!showUncertainty">{{ displayedColumnNames.error }}</th>
                        <td mat-cell *matCellDef="let element" [hidden]="!showUncertainty">{{ element.error.display.trim() }}</td>
                    </ng-container>

                    <ng-container matColumnDef="grade">
                        <th mat-header-cell *matHeaderCellDef> {{ displayedColumnNames.grade }} </th>
                        <td mat-cell *matCellDef="let element">
                            <app-grade-bar *ngIf="element.showGrade" [ShotGradeSpec]="element.grade"></app-grade-bar>
                            <span [style.color]="element.color" *ngIf="!element.showGrade">{{ element.grade }}</span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="flex-column flex-0-0-auto" *ngIf="showEstimatedLod">
                    <div class="lod-title">
                        <span>&lt; LOD</span>
                    </div>
                    <table #table2 *ngIf="!hideChemistry" mat-table [dataSource]="tableDataSource2" matSort #sort2="matSort" matSortDisableClear class="full-width"
                           matSortActive="elementName" matSortDirection="desc">
                        <ng-container matColumnDef="elementName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ displayedColumnNames2.elementName }} </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="element-badge"
                                      [matTooltip]="getElementFullName(element.elementName.display)"
                                      matTooltipPosition="right"
                                      matTooltipShowDelay="200"
                                      [class.out-of-spec]="element.outOfSpec"
                                      [innerHtml]="element.elementName.display.trim()">
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="concentration">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ displayedColumnNames2.concentration }} </th>
                            <td mat-cell *matCellDef="let element"> {{ element.concentration.display.trim() }} </td>
                        </ng-container>

                        <ng-container matColumnDef="error">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="!showUncertainty">{{ displayedColumnNames2.error }}</th>
                            <td mat-cell *matCellDef="let element" [hidden]="!showUncertainty">{{ element.error.display.trim() }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns2; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #spectrum>
            <div class="data__chart spectrum-tab">
                <div #chart id="chart"></div>

                <div class="data__chart-controls flex-column gap-5">
                    <button mat-icon-button (click)="resetChart()">
                        <mat-icon inline="true">undo</mat-icon>
                    </button>
                    <button mat-icon-button (click)="selectElements()">
                        <mat-icon inline="true" svgIcon="periodic" class="svg-fix"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="selectLines()">
                        <mat-icon inline="true" svgIcon="energy" class="svg-fix"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="print()">
                        <mat-icon inline="true">file_download</mat-icon>
                    </button>
                </div>
            </div>
        </ng-template>


        <ng-template #notes>
            <div *ngIf="infoShowBlade && infoShowBlade.notes" class="notes__table fill flex-column gap-10">
                <div class="notes__table-header flex-row gap-2">
                    <span class="flex-1-1-49">Title</span>
                    <span class="flex-1-1-49">Contents</span>
                </div>
                <div *ngFor="let note of infoShowBlade.notes | keyvalue" class="flex-row gap-2">
                    <span class="flex-1-1-49">{{note.key}}</span>
                    <span class="flex-1-1-49">{{note.value}}</span>
                </div>
            </div>
            <div *ngIf="infoShowBlade">
                <span *ngIf="!infoShowBlade.notes">There are no notes available.</span>
            </div>
        </ng-template>

        <!--
      Map functionality is currently disabled.
      To enable, obtain a Google Maps JavaScript API key:
       https://developers.google.com/maps/documentation/javascript/get-api-key
    -->
        <!-- <ng-template #map>
      <agm-map [latitude]="optionMaps.latitude" [longitude]="optionMaps.longitude"
           [minZoom]="optionMaps.minZoom" [fitBounds]="true">
        <agm-marker-cluster [imagePath]="'./assets/img/m'">
          <ng-container *ngFor="let item of searchResultItem">
            <agm-marker [iconUrl]="'./assets/img/mark_Olympus.png'" *ngIf="item.latitude"
                  [latitude]="item.latitude " [longitude]="item.longitude" [agmFitBounds]="true">
            </agm-marker>
          </ng-container>
        </agm-marker-cluster>
      </agm-map>
    </ng-template> -->
